import { put, takeLatest, call } from 'redux-saga/effects';
import Pagination from '../interfaces/common/pagination';
import HttpErrorResponse from '../interfaces/common/httpErrorResponse';
import { PayloadAction } from '@reduxjs/toolkit';
import Paging from '../interfaces/common/paging';
import CorrectedStatusApi from '../api/correctedStatusApi';
import CorrectedStatus from '../interfaces/output/correctedStatus';
import { fetchCorrectedStatusByIdError, fetchCorrectedStatusByIdSuccess, fetchCorrectedStatusesError, fetchCorrectedStatusesSuccess } from '../reducers/correctedStatusReducer';

function* doFetchCorrectedStatus(action: PayloadAction<string>) {
    const correctedStatusId = action.payload;
    try {
        const response: CorrectedStatus = yield call(CorrectedStatusApi.fetchCorrectedStatusById, correctedStatusId);
        yield put(fetchCorrectedStatusByIdSuccess(response));
    }

    catch (error: unknown) {
        yield put(fetchCorrectedStatusByIdError(error as HttpErrorResponse));
    }
}

function* doFetchCorrectedStatuses(action: PayloadAction<{ paging: Paging}>) {
    const { paging } = action.payload;
    try {
        const response: Pagination<CorrectedStatus> = yield call(CorrectedStatusApi.fetchCorrectedStatuses, paging);
        yield put(fetchCorrectedStatusesSuccess(response));
    }

    catch (error: unknown) {
        yield put(fetchCorrectedStatusesError(error as HttpErrorResponse));
    }
}

export default [
    takeLatest('correctedStatus/fetchCorrectedStatusById', doFetchCorrectedStatus),
    takeLatest('correctedStatus/fetchCorrectedStatuses', doFetchCorrectedStatuses)
];

